import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import Tutorsmodel from "../../models/tutors.modal";
import TutorLeaderboard from "../../models/tutorleaderboard.modal";
import { helper } from "lib/helper";

const Tutorleaderboard = () => {
  const [tutordata, setTutordata] = useState();
  const [leaderlist, setLeaderlist] = useState();

  console.log("tutor", leaderlist);
  const [modal, setModal] = useState();
  const toggleModal = () => {
    setModal(!modal);
  };
  const Addleader = async (event) => {
    event.preventDefault();
    const form = new FormData(event.target);
    form.append("rank_type", "tutor");

    TutorLeaderboard.Addlist(form)
      .then((responce) => {
        console.log("red", responce);
        helper.sweetalert.toast(responce?.data?.message);
        Leaderlist();
        toggleModal();
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const TutorList = () => {
    Tutorsmodel.GetAllTutor()
      .then((responce) => {
        setTutordata(responce?.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  useEffect(() => {
    TutorList();
    Leaderlist();
  }, []);
  const Leaderlist = async () => {
    TutorLeaderboard.Getlist()

      .then((responce) => {
        console.log("tutor leader Board", responce);
        setLeaderlist(responce);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  return (
    <Container className="px-4 py-7">
      <Card className="shadow">
        <CardHeader className="border-0 d-flex justify-content-between ">
          <h3 className="mb-0">Tutor Leader Board</h3>

          <div className="d-flex flex-row">
            <Button
              size="sm"
              onClick={toggleModal}
              style={{ backgroundColor: "#080278", color: "white" }}
            >
              +Add
            </Button>
          </div>
        </CardHeader>

        <CardBody>
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th>S.NO</th>

                <th>Leader 1</th>
                <th>Leader 2</th>

                <th>Leader 3</th>
                <th>Month</th>
              </tr>
            </thead>
            <tbody>
              {leaderlist?.data?.map((item, index) => {
                console.log("list", item);
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    <td>
                      {item?.rank1?.first_name} {item?.rank1?.last_name}
                    </td>
                    <td>
                      {item?.rank2?.first_name} {item?.rank2?.last_name}
                    </td>

                    <td>
                      {item?.rank3?.first_name} {item?.rank3?.last_name}
                    </td>
                    <td
                      style={{
                        alignItems: "center",

                        display: "flex",
                      }}
                    >
                      {item?.month_name}
                    </td>
                  </tr>
                );
              })}
              {leaderlist?.data?.length === 0 && (
                <tr style={{ textAlign: "center" }}>
                  <td colSpan="5" style={{ verticalAlign: "middle" }}>
                    No data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          {/*add banner module */}
          <Modal isOpen={modal} toggle={toggleModal} size="md">
            <ModalHeader toggle={toggleModal}>
              <h4> Add Tutor Leader List </h4>
            </ModalHeader>
            <ModalBody>
              <Form onSubmit={Addleader}>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label> Month</Label>
                      <Input
                        name="month_name"
                        type="text"
                        placeholder="Enter Month"
                        style={{
                          border: "1px solid #cad1d7",
                          borderRadius: "0.375rem",
                          padding: "4px",
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label>Leader 1</Label>
                      <Input
                        name="rank_1"
                        type="select"
                        placeholder="Enter Vedio Type"
                      >
                        <option value="">Select</option>
                        {tutordata?.data?.map((item, index) => {
                          return (
                            <option value={item?.user?.id}>
                              {item?.user?.first_name} {item?.user?.last_name}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Label> Leader 2</Label>
                      <Input name="rank_2" type="select">
                        <option value="parent">Select</option>
                        {tutordata?.data?.map((item, index) => {
                          return (
                            <option value={item?.user?.id}>
                              {item?.user?.first_name} {item?.user?.last_name}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={12}>
                    <FormGroup>
                      <Label>Leader 3</Label>
                      <Input name="rank_3" type="select">
                        <option value="">Select</option>
                        {tutordata?.data?.map((item, index) => {
                          return (
                            <option value={item?.user?.id}>
                              {item?.user?.first_name} {item?.user?.last_name}
                            </option>
                          );
                        })}
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                  }}
                >
                  <Button color="secondary" onClick={toggleModal}>
                    Cancel
                  </Button>
                  {/* 
                    {addsLoadig ? (
                      <Loader color={"blue"} />
                    ) : ( */}
                  <Button
                    color="primary"
                    type="submit"
                    style={{
                      float: "right",
                      marginLeft: "5%",
                      backgroundColor: "#080278",
                      color: "white",
                    }}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </ModalBody>
          </Modal>
          {/*end*/}
        </CardBody>
      </Card>
    </Container>
  );
};

export default Tutorleaderboard;
